export enum ImagePickerSourceHint {
    CameraOnly = "CameraOnly",
    Any = "Any",
}

export enum ImageSizePreset {
    Low = "low",
    High = "high",
    Original = "original",
}

export function getDimensionsForPreset(preset: ImageSizePreset): { maxWidth: number; maxHeight: number } | undefined {
    switch (preset) {
        case ImageSizePreset.Low:
            return { maxWidth: 1280, maxHeight: 1280 };
        case ImageSizePreset.High:
            return { maxWidth: 2560, maxHeight: 2560 };
        case ImageSizePreset.Original:
        default:
            return undefined;
    }
}
